import React, { useEffect, useState } from "react";
import "./Users.css";
import { Row, Col } from "antd";
import { EditOutlined, SearchOutlined, UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import randomstring from "randomstring";
import {
  Space,
  Table,
  Tag,
  Button,
  Input,
  notification,
  Checkbox,
} from "antd";
import { BaseUrl } from "../../Constants/Constants";
import Lottie from "lottie-react";
import createLoaderjson from "../../LottieAnimation/loading-dots.json";
import BulkUpload from "./BulkUpload";
import AddEditUserModal from "./AddEditUserModal";

const Users = () => {
  // Table Data States
  const [Data, setData] = useState([]);
  const [clearTableData, setClearTableData] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [LoadTable, setLoadTable] = useState(false);
  
  // Modal States
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenLogin, setIsModalOpenLogin] = useState(false);
  const [bulkModalOpen, setBulkModalOpen] = useState(false);
  const [CreateLoader, setCreateLoader] = useState(false);
  
  // Form States
  const [UserName, setUserName] = useState("");
  const [Email, setEmail] = useState("");
  const [Status, setStatus] = useState(null);
  const [Password, setPassword] = useState("");
  const [teamId, setteamId] = useState(null);
  const [TeamNameDefault, setTeamNameDefault] = useState("");
  const [TeamId, setTeamId] = useState("");
  const [CompanyId, setCompanyId] = useState(null);
  const [selectedUserId, setselectedUserId] = useState("");
  const [Role, setRole] = useState("user");
  const [EmployeeId, setEmployeeId] = useState("");
  const [isNewBatch, setIsNewBatch] = useState(false);
  const [managerId, setManagerId] = useState(null);
  
  // Dropdown Options
  const [Options, setOptions] = useState({});
  const [CompanyOptions, setCompanyOptions] = useState([]);
  const [TeamOptions, setTeamOptions] = useState([]);
  const [managerOptions, setManagerOptions] = useState([]);
  
  // Level, Domain, Department States
  const [level, SetLevel] = useState(null);
  const [levels, setLevels] = useState([
    "Executive Management",
    "Core Team",
    "Entry Level",
    "VRAs",
  ]);
  const [newLevel, setNewLevel] = useState("");
  
  const [domain, setDomain] = useState(null);
  const [domains, setDomains] = useState([
    "Marketing",
    "Tech",
    "HR",
    "IT",
    "Admin",
    "Compliance",
    "QA",
    "Procurement",
    "All Managers",
    "IT Security",
  ]);
  const [NewDomain, setNewDomain] = useState("");
  
  const [department, setDepartment] = useState(null);
  const [departments, setDepartments] = useState([
    "Development",
    "Testing",
    "Devops",
    "Product Management",
    "Business Analysis",
  ]);
  const [NewDepartment, setNewDepartment] = useState("");
  
  // Filter States
  const [searchEmail, setSearchEmail] = useState("");
  const [showInactive, setshowInactive] = useState(false);
  const [listNewBatch, setListNewBatch] = useState("");
  
  // Error States
  const [errors, setErrors] = useState(false);
  const [emailError, setEmailError] = useState("");
  
  // Notification
  const [api, contextHolder] = notification.useNotification();

  // Validation
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  // Password Generator
  const generatePassword = () => {
    const length = 8;
    const alphanumeric =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const specialCharacters = "!@#$%&*()_+[]{}?";

    let passwordStr = "";
    passwordStr += randomstring.generate({
      length: 1,
      charset: "0123456789",
    });
    passwordStr += randomstring.generate({
      length: 1,
      charset: specialCharacters,
    });
    passwordStr += randomstring.generate({
      length: length - 2,
      charset: alphanumeric + specialCharacters,
    });

    return passwordStr
      .split("")
      .sort(() => Math.random() - 0.5)
      .join("");
  };

  // Email Template
  const createEmailTemplate = (userName, email, password) => {
    return `
      <!DOCTYPE html>
      <html>
      <head>
        <style>
          body {
            font-family: Arial, sans-serif;
            background-color: #f4f4f4;
            margin: 0;
            padding: 0;
          }
          .container {
            background-color: #f4f4f4;
            margin: 20px auto;
            padding: 20px;
            max-width: 600px;
          }
          .card {
            background-color: #ffffff;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }
          .header {
            background-color: #0073e6;
            padding: 10px;
            border-radius: 8px 8px 0 0;
            text-align: center;
            color: #ffffff;
          }
          .content {
            padding: 20px;
            text-align: center;
          }
          .content p {
            margin: 0;
            line-height: 1.5;
            color: #555555;
          }
          .button-container {
            margin: 20px 0;
            text-align: center;
          }
          .button {
            background-color: #0073e6;
            color: #ffffff !important;
            padding: 9px 20px;
            border-radius: 5px;
            border: 1px solid #0073e6;
            text-decoration: none;
            display: inline-block;
            transition: background-color 0.3s ease;
          }
          .button:hover {
            background-color: #ffffff;
            border: 1px solid #0073e6;
            color: #0073e6 !important;
          }
          .footer {
            padding: 10px;
            text-align: center;
            color: #777777;
            font-size: 12px;
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="card">
            <div class="header">
              <h1>Welcome to Training Nexus!</h1>
            </div>
            <div class="content">
              <p>Dear <strong>${userName}</strong>,</p>
              <p>Welcome to our digital learning platform! 🚀</p>
              <p>We're thrilled to have you onboard and are excited to help you unlock your full potential through our interactive courses.</p>
              <p>Your personalised access details are as follows:</p>
              <p><strong>Username:</strong> ${email.toLowerCase()}</p>
              <p><strong>Password:</strong> ${password}</p>
              <div class="button-container">
                <a href="https://training-nexus.valuehealthsolutions.com/login" class="button">Click here to Login</a>
              </div>
              <p>Thank you for registering in the portal to embark on your learning journey! Please reach out to <a href="mailto:srinivasan.s@valuehealthsol.com">srinivasan.s@valuehealthsol.com</a> for any questions and clarifications.</p>
            </div>
            <div class="footer">
              <p>Best regards,<br>Value Health Solutions</p>
            </div>
          </div>
        </div>
      </body>
      </html>
    `;
  };

  // Notifications
  const openNotificationWithIconWarning = (type) => {
    api["warning"]({
      message: "Warning!!!",
      description: type,
    });
  };

  const openNotificationWithIconSuccess = (type) => {
    api["success"]({
      message: "Mail sent",
      description: type,
    });
  };

  const openNotificationWithIconSuccess1 = (type) => {
    api["success"]({
      message: "Details Updated",
      description: type,
    });
  };

  // Modal Handlers - Edit User
  const showModal = (e) => {
    setUserName(e.username);
    setEmail(e.email.toLowerCase());
    setTeamNameDefault(e.team);
    setTeamId(e.teamId);
    setselectedUserId(e.user_id);
    setCompanyId(e.companyId);
    setEmployeeId(e.EmployeeId);
    setStatus(JSON.stringify(e.IsActive));
    setIsNewBatch(e.isNewBatch);
    SetLevel(e.level);
    setDomain(e.domain);
    setDepartment(e.department);
    setManagerId(e.managerId);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setCreateLoader(true);
    setLoadTable(true);
    let body = {
      username: UserName,
      email: Email.toLowerCase(),
      IsActive: JSON.parse(Status),
      companyid: CompanyId,
      team_id: TeamId,
      level: level,
      domain: domain,
      department: department,
      user_id: selectedUserId,
      employeeId: EmployeeId,
      new_batch: isNewBatch,
      manager: managerId,
    };
    axios
      .post(`${BaseUrl}users/update`, body, { withCredentials: true })
      .then((res) => {
        setIsModalOpen(false);
        setCreateLoader(false);
        setUserName("");
        setLoadTable(false);
        setEmail("");
        setStatus("");
        openNotificationWithIconSuccess1("User Details Updated Sucessfully");
      })
      .catch((err) => {
        setCreateLoader(false);
        openNotificationWithIconWarning("Invalid Entry!");
        setIsModalOpen(false);
        setUserName("");
        setEmail("");
        setStatus("");
      });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setUserName("");
    setEmail("");
    setStatus("");
  };

  // Modal Handlers - Add User
  const showModalLogin = (e) => {
    setIsModalOpenLogin(true);
  };

  const handleOkAdd = () => {
    setErrors(true);

    if (
      UserName !== "" &&
      Email !== "" &&
      Status !== null &&
      Role !== null &&
      teamId !== null
    ) {
      if (validateEmail(Email)) {
        setLoadTable(false);
        setCreateLoader(true);

        const password1 = generatePassword();
        setPassword(password1);

        if (password1) {
          const template = createEmailTemplate(UserName, Email, password1);

          let body = {
            email: Email.toLowerCase(),
            subject: "Login Details for Training Nexus",
            template: template,
          };

          axios
            .post(`${BaseUrl}email-service`, body, { withCredentials: true })
            .then((res) => {
              let Body = {
                userName: UserName,
                userPassword: password1,
                Email: Email.toLowerCase(),
                IsActive: true,
                role: Role,
                companyid: Status,
                teamid: teamId,
                employeeId: EmployeeId,
                level: level,
                domain: domain,
                department: department,
                new_batch: isNewBatch,
                manager: managerId,
              };
              axios
                .post(`${BaseUrl}auth/signup`, Body, { withCredentials: true })
                .then((res) => {
                  if (res.data.status === 204) {
                    openNotificationWithIconWarning("User Already Exists");
                    setIsModalOpenLogin(false);
                  } else if (res.data.status == "Error") {
                    openNotificationWithIconWarning("User Already Exists");
                    setIsModalOpenLogin(false);
                  } else {
                    openNotificationWithIconSuccess("User Added Sucessfully");
                    setLoadTable(true);
                    setIsModalOpenLogin(false);
                  }
                })
                .catch((err) => {
                  if (err.status == 409) {
                    setIsModalOpenLogin(false);
                    openNotificationWithIconWarning("User Already exist");
                  }
                })
                .finally(() => {
                  setCreateLoader(false);
                });
            })
            .catch((err) => {
              setCreateLoader(false);
              openNotificationWithIconWarning(
                "Failed to send registration email."
              );
            });
        }
      } else {
        setEmailError("Please enter a valid email address.");
        setCreateLoader(false);
      }
    } else {
      openNotificationWithIconWarning("Please Enter User Details");
      setCreateLoader(false);
    }
  };

  const handleCancelAdd = () => {
    setIsModalOpenLogin(false);
    setErrors(false);
    setEmail("");
    setEmployeeId("");
    setUserName("");
    setRole("user");
    setCompanyId(null);
    setTeamId(null);
  };

  // Level Handlers
  const handleLevelAdd = () => {
    if (newLevel && !levels.includes(newLevel)) {
      setLevels([...levels, newLevel]);
      setNewLevel("");
    }
  };

  const handleLevelDelete = () => {
    if (level) {
      setLevels(levels.filter((lvl) => lvl !== level));
      SetLevel(undefined);
    }
  };

  const handleChangeLevel = (val) => {
    SetLevel(val);
    setErrors(false);
  };

  // Domain Handlers
  const handleDomainAdd = () => {
    if (NewDomain && !domains.includes(NewDomain)) {
      setDomains([...domains, NewDomain]);
      setNewDomain("");
    }
  };

  const handleDomainDelete = () => {
    if (domain) {
      setDomains(domains.filter((dom) => dom !== domain));
      setDomain(undefined);
    }
  };

  const handleChangeDomain = (val) => {
    setDomain(val);
    setErrors(false);
  };

  // Department Handlers
  const handleDepartmentAdd = () => {
    if (NewDepartment && !departments.includes(NewDepartment)) {
      setDepartments([...departments, NewDepartment]);
      setNewDepartment("");
    }
  };

  const handleDepartmentDelete = () => {
    if (department) {
      setDepartments(departments.filter((dept) => dept !== department));
      setDepartment(undefined);
    }
  };

  const handleChangeDepartment = (val) => {
    setDepartment(val);
    setErrors(false);
  };

  // Other Handlers
  const handleChange = (value) => {
    setStatus(value);
  };

  const handlechangeTeam = (val) => {
    setTeamId(val);
  };

  const handleChangeRole = (val) => {
    setRole(val);
  };

  const handleChangeTeam = (value) => {
    setteamId(value);
    setTeamId(value);
  };

  const handleChangeManager = (val) => {
    setManagerId(val);
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
    setEmailError("");
  };

  const CheckboxChange = (e) => {
    setshowInactive(e.target.checked);
  };

  // Table Columns
  const columns = [
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <EditOutlined className="Edit" onClick={(e) => showModal(record)} />
        </Space>
      ),
    },
    {
      title: "Employee Id",
      dataIndex: "EmployeeId",
      key: "EmployeeId",
      align: "center",
    },
    {
      title: "Name",
      dataIndex: "username",
      key: "username",
      align: "center",
      render: (text) => <p className="NameTxt">{text}</p>,
    },
    {
      title: "Team",
      dataIndex: "team",
      key: "team",
      align: "center",
      render: (text) => <p className="NameTxt">{text}</p>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      align: "center",
    },
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      align: "center",
    },
    {
      title: "Domain",
      dataIndex: "domain",
      key: "domain",
      align: "center",
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "IsActive",
      key: "IsActive",
      render: (isActive) => (
        <Tag color={isActive ? "green" : "red"}>
          {isActive ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Created Date Time",
      dataIndex: "created_date",
      key: "created_date",
      align: "center",
    },
    {
      title: "New Batch",
      dataIndex: "isNewBatch",
      key: "isNewBatch",
      align: "center",
      render: (value) => (value ? "✅" : "❌"),
    },
  ];

  // API Calls
  const Tabledata = () => {
    setLoading(true);
    axios
      .get(`${BaseUrl}users`, { withCredentials: true })
      .then((res) => {
        const transformedData = res.data.map((item) => {
          const createdAt = new Date(item.created_at);
          const createdDate = createdAt.toLocaleDateString();
          const createdTime = createdAt.toLocaleTimeString();

          return {
            EmployeeId: item.employee_id,
            IsActive: item.IsActive,
            email: item.email,
            key: item.key,
            team: item.team_id.Team_name,
            user_id: item.user_id,
            username: item.username,
            companyId: item.team_id.Company_id,
            teamId: item.team_id.team_id,
            level: item.level,
            domain: item.domain,
            department: item.department,
            managerId: item.manager,
            created_date: `${createdDate} ${createdTime}`,
            created_time: createdTime,
            isNewBatch: Boolean(item.new_batch),
            listNewBatch: Boolean(item.new_batch),
          };
        });

        transformedData.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

        setData(transformedData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const companyData = () => {
    axios
      .get(`${BaseUrl}company`, { withCredentials: true })
      .then((res) => {
        const transformedArray = res.data.map((item) => ({
          label: item.company_mail.toUpperCase(),
          value: item.company_id,
        }));
        setCompanyOptions(transformedArray);
      })
      .catch((err) => {
        console.error("Error fetching companies:", err);
      });
  };

  const teamdata = () => {
    axios
      .get(`${BaseUrl}teams`, { withCredentials: true })
      .then((res) => {
        setOptions(res.data);
        const transformedArray = res.data.map((item) => ({
          label: item.Team_name.toUpperCase(),
          value: item.team_id,
        }));
        setTeamOptions(transformedArray);
      })
      .catch((err) => {
        console.error("Error fetching teams:", err);
      });
  };

  const managerdata = () => {
    axios
      .get(`${BaseUrl}managers`, { withCredentials: true })
      .then((res) => {
        const transformedArray = res.data.map((item) => ({
          label: item.name,
          value: item.manager_id,
        }));
        setManagerOptions(transformedArray);
      })
      .catch((err) => {
        console.error("Error fetching managers:", err);
      });
  };

  // Effects
  useEffect(() => {
    Tabledata();
    companyData();
    teamdata();
    managerdata();
  }, [LoadTable]);

  useEffect(() => {
    if (searchEmail === "") {
      setClearTableData(Data);
      return;
    }

    const filteredEmails = Data.filter((item) =>
      item.email.toLowerCase().includes(searchEmail.toLowerCase())
    );
    setClearTableData(filteredEmails);
  }, [searchEmail, Data]);

  // Filtered Users
  const filteredUsers = clearTableData
    .filter((user) => {
      if (showInactive && !user.IsActive) return true;
      if (!showInactive && user.IsActive) return true;
      return false;
    })
    .filter((user) => {
      if (listNewBatch) return user.listNewBatch === true;
      return true;
    });

  return (
    <div className="Users-main">
      {contextHolder}

      {/* Loading Overlay */}
      {CreateLoader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Lottie
            animationData={createLoaderjson}
            loop={true}
            style={{ height: 150, width: 150 }}
          />
        </div>
      )}

      {/* Edit User Modal */}
      <AddEditUserModal
        isOpen={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        modalType="edit"
        EmployeeId={EmployeeId}
        setEmployeeId={setEmployeeId}
        UserName={UserName}
        setUserName={setUserName}
        Email={Email}
        setEmail={setEmail}
        Status={Status}
        setStatus={setStatus}
        Role={Role}
        setRole={setRole}
        level={level}
        SetLevel={SetLevel}
        domain={domain}
        setDomain={setDomain}
        department={department}
        setDepartment={setDepartment}
        managerId={managerId}
        setManagerId={setManagerId}
        teamId={teamId}
        setteamId={setteamId}
        TeamId={TeamId}
        setTeamId={setTeamId}
        isNewBatch={isNewBatch}
        setIsNewBatch={setIsNewBatch}
        TeamNameDefault={TeamNameDefault}
        CompanyOptions={CompanyOptions}
        TeamOptions={TeamOptions}
        managerOptions={managerOptions}
        levels={levels}
        setLevels={setLevels}
        domains={domains}
        setDomains={setDomains}
        departments={departments}
        setDepartments={setDepartments}
        errors={errors}
        emailError={emailError}
        handleEmail={handleEmail}
        newLevel={newLevel}
        setNewLevel={setNewLevel}
        handleLevelAdd={handleLevelAdd}
        handleLevelDelete={handleLevelDelete}
        NewDomain={NewDomain}
        setNewDomain={setNewDomain}
        handleDomainAdd={handleDomainAdd}
        handleDomainDelete={handleDomainDelete}
        NewDepartment={NewDepartment}
        setNewDepartment={setNewDepartment}
        handleDepartmentAdd={handleDepartmentAdd}
        handleDepartmentDelete={handleDepartmentDelete}
        handleChange={handleChange}
        handlechangeTeam={handlechangeTeam}
        handleChangeRole={handleChangeRole}
        handleChangeLevel={handleChangeLevel}
        handleChangeDomain={handleChangeDomain}
        handleChangeDepartment={handleChangeDepartment}
        handleChangeTeam={handleChangeTeam}
        handleChangeManager={handleChangeManager}
      />

      {/* Add User Modal */}
      <AddEditUserModal
        isOpen={isModalOpenLogin}
        onOk={handleOkAdd}
        onCancel={handleCancelAdd}
        modalType="add"
        EmployeeId={EmployeeId}
        setEmployeeId={setEmployeeId}
        UserName={UserName}
        setUserName={setUserName}
        Email={Email}
        setEmail={setEmail}
        Status={Status}
        setStatus={setStatus}
        Role={Role}
        setRole={setRole}
        level={level}
        SetLevel={SetLevel}
        domain={domain}
        setDomain={setDomain}
        department={department}
        setDepartment={setDepartment}
        managerId={managerId}
        setManagerId={setManagerId}
        teamId={teamId}
        setteamId={setteamId}
        TeamId={TeamId}
        setTeamId={setTeamId}
        isNewBatch={isNewBatch}
        setIsNewBatch={setIsNewBatch}
        TeamNameDefault={TeamNameDefault}
        CompanyOptions={CompanyOptions}
        TeamOptions={TeamOptions}
        managerOptions={managerOptions}
        levels={levels}
        setLevels={setLevels}
        domains={domains}
        setDomains={setDomains}
        departments={departments}
        setDepartments={setDepartments}
        errors={errors}
        emailError={emailError}
        handleEmail={handleEmail}
        newLevel={newLevel}
        setNewLevel={setNewLevel}
        handleLevelAdd={handleLevelAdd}
        handleLevelDelete={handleLevelDelete}
        NewDomain={NewDomain}
        setNewDomain={setNewDomain}
        handleDomainAdd={handleDomainAdd}
        handleDomainDelete={handleDomainDelete}
        NewDepartment={NewDepartment}
        setNewDepartment={setNewDepartment}
        handleDepartmentAdd={handleDepartmentAdd}
        handleDepartmentDelete={handleDepartmentDelete}
        handleChange={handleChange}
        handlechangeTeam={handlechangeTeam}
        handleChangeRole={handleChangeRole}
        handleChangeLevel={handleChangeLevel}
        handleChangeDomain={handleChangeDomain}
        handleChangeDepartment={handleChangeDepartment}
        handleChangeTeam={handleChangeTeam}
        handleChangeManager={handleChangeManager}
      />

      {/* Header */}
      <div className="addCourceandHeading">
        <h2>Users</h2>
        <Checkbox onChange={CheckboxChange}>Show Inactive Users</Checkbox>
      </div>

      {/* Action Buttons */}
      <Row justify="end" align="middle">
        <Col>
          <Space size="middle">
            <div style={{ position: "relative" }}>
              <Input
                placeholder="Search by E-mail"
                className="searchInput"
                onChange={(e) => setSearchEmail(e.target.value)}
              />
              <SearchOutlined className="inputSearch" />
            </div>

            <Button
              icon={<UploadOutlined />}
              onClick={() => setBulkModalOpen(true)}
            >
              Bulk Upload
            </Button>

            <Button type="primary" onClick={showModalLogin}>
              Add Users
            </Button>
          </Space>
        </Col>
      </Row>

      {/* User Table */}
      {Loading ? (
        <div className="Loader">
          <img src="Loader\Ellipsis-2.9s-200px.svg" alt="Loading" />
        </div>
      ) : (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              margin: "10px 0",
            }}
          >
            <Checkbox
              checked={listNewBatch}
              onChange={(e) => setListNewBatch(e.target.checked)}
            >
              Show New Batch Users Only
            </Checkbox>
          </div>

          <Table
            columns={columns}
            dataSource={filteredUsers}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: false,
            }}
            scroll={{
              y: 300,
            }}
          />
        </div>
      )}

      {/* Bulk Upload Modal Component */}
      <BulkUpload
        visible={bulkModalOpen}
        onClose={() => setBulkModalOpen(false)}
        CompanyOptions={CompanyOptions}
        TeamOptions={TeamOptions}
        managerOptions={managerOptions}
        levels={levels}
        domains={domains}
        departments={departments}
        onUploadComplete={() => setLoadTable(true)}
      />
    </div>
  );
};

export default Users;